var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canInit)?_c('js-loader',{staticClass:"GigyaInitializer",attrs:{"data-id":"gigya-initializer","data-src":("//cdns." + _vm.dataCenter + "/js/gigya.js?apiKey=" + _vm.apiKey + "&lang=" + _vm.lang)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }